import { TableCacheNameEnum } from '../../../../hooks/useTableChange/useTableChange';
import { PatientListTypeEnum } from '../../../../uc-api-sdk';
import { AllPatientsTableComponent } from '../../component/AllPatientsTableComponent/AllPatientsTableComponent';
import { PatientsTableContainer } from '../PatientsTableContainer/PatientsTableContainer';

export interface AllPatientsTableContainerProps {

}

export const AllPatientsTableContainer = () => (
  <PatientsTableContainer
    type={PatientListTypeEnum.ALL}
    name={TableCacheNameEnum.AllPatients}
  >
    {({
      totalSize,
      pagination,
      dataSource,
      onChange,
      filters,
      sorters,
      isLoading,
      exportData,
    }) => (
      <AllPatientsTableComponent
        totalSize={totalSize}
        pagination={pagination}
        dataSource={dataSource}
        onChange={onChange}
        filters={filters}
        sorters={sorters}
        loading={isLoading}
        exportData={exportData}
      />
    )}
  </PatientsTableContainer>
);
